import React, { Component } from "react";
import { RichText, Image } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import Rimage from "../../elements/image";
import { withRouter } from "react-router-dom";
// import { isIframe, isNestedGrid} from "../../redux/actions/model";
import { connect } from "react-redux";
// import Heading from "../../elements/heading";
// import { addTransition } from "../../redux/actions/actions";

class ListContentItem extends Component {
  // constructor(props, context) {
  //   super(props, context);
  // }
  handleClick(event) {
    let model = this.props.fields ? this.props.fields : {};
    if (this.props.showModal && this.props.showModal.value) {
      let href = "";
      if (this.props.fields.link && this.props.fields.link.value) {
        if (this.props.fields.link.value.linktype === "internal") {
          href =
            window.location.protocol +
            "//" +
            window.location.host +
            this.props.fields.link.value.href;
        } else if (this.props.fields.link.value.linktype === "external") {
          href = this.props.fields.link.value.href;
        }
      }
      let item = {
        href: href
      };
      this.props.toggleIframe(item);
      return false;
    }

    if (model.link && model.link.value) {
      if (model.hrefboolean) {
        this.props.history.push(model.link.value.href);
      } else {
        window.open(model.link.value.href);
      }
    }
  }
  item(model) {
    const author = {
      value: model.author && model.author.value ? model.author.value : "&nbsp"
    };
    let { showCategory } = this.props,
    showCategoryValue = showCategory ? showCategory.value : true;
    return (
      <div className={"grid full-width wrapper"}>
        {showCategoryValue && model.type && model.type.value && (
          <RichText tag="span" className={"type"} field={model.type} />
        )}
        {!showCategoryValue && model.type && model.type.value && (
          <span className={"type"}></span>
        )}
        <div className={"image-container"}>
          {model.image && model.image.value.src && (
            <Rimage {...model.image.value} />
          )}
        </div>
        <div className="avatar-author-container">
          {model.profileImage &&
            model.profileImage.value &&
            model.profileImage.value.src && (
              <Image className={"avatar"} field={model.profileImage} />
            )}
          <RichText tag="span" className={"author"} field={author} />
        </div>
        {model.localDate && (
          <span className={"timestamp"}>{model.localDate.value}</span>
        )}
        {model.headingBody && (
          <span className="title">
            <span className="type-h4">{model.headingBody.value}</span>
          </span>
          // <Heading
          //   className={"title type-h4"}
          //   type={model.headingType}
          //   html={model.headingBody}
          // />
        )}
        {model.subjects && model.subjects.length > 0 && (
          <div className={"subject-list"}>
            {model.subjects.map((subject, index) => {
              if (subject) {
                return (
                  <RichText
                    tag="span"
                    className={"subject"}
                    key={index}
                    field={subject.fields.phrase}
                  />
                );
              }
              return null;
            })}
          </div>
        )}
      </div>
    );
  }

  render() {
    const itemClasses = classNames("auto-list-content-item", "grid");
    let model = this.props.fields ? this.props.fields : {};
    let monthArr = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June ",
      "July",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    if (
      model.timestamp != null &&
      model.timestamp.value != null &&
      model.timestamp.value
    ) {
      let date = model.timestamp.value.split("T")[0].split("-");
      let localDate =
        date[0] !== "0001" ? monthArr[Number(date[1]) - 1] + " " + date[0] : "";
      model.localDate = {
        value: localDate
      };
    }
    model.hrefboolean = true;
    if (model.link && model.link.value.href && model.link.value.href.indexOf("http") !== -1) {
      model.hrefboolean = false;
    }
    return (
      <div className={itemClasses}>
        {/* {model.link.value.href && ( */}
        <div
          className={"link full-width grid"}
          onClick={e => {
            this.handleClick(e);
          }}
        >
          {this.item(model)}
        </div>
        {/*{model.link.value.href && model.hrefboolean && (*/}
        {/*  <Link to={model.link.value.href} className={"link full-width grid"}>*/}
        {/*    {this.item(model)}*/}
        {/*  </Link>*/}
        {/*)}*/}
        {/*{model.link.value.href && !model.hrefboolean && (*/}
        {/*  <a href={model.link.value.href} className={"link full-width grid"} target="_blank">*/}
        {/*    {this.item(model)}*/}
        {/*  </a>*/}
        {/*)}*/}
      </div>
    );
  }
}
const mapDispatchToProps = {
  // isIframe: isIframe,
  // isNestedGrid: isNestedGrid
};
export default withRouter(connect(null, mapDispatchToProps)(ListContentItem));
